import { LitElement, html, TemplateResult } from 'lit';
import { property, customElement } from 'lit/decorators.js';
import { styles } from '../view/styles';
import { isEmpty } from '@nestjs/common/utils/shared.utils';
import { SwitchConfig, LabelSwitchEvents } from '../types';
import { ifDefined } from 'lit/directives/if-defined.js';

/**
 * @summary This is a switch component that allows value as labels
 * @tag gz-label-switch
 * Here https://custom-elements-manifest.open-wc.org/analyzer/getting-started/ you can find out how to document the code
 */
@customElement('gz-label-switch')
export class GzLabelSwitchWebComponent extends LitElement {
  static get styles() {
    return styles;
  }

  @property({ type: Object, attribute: true, reflect: true })
  itemLeft: SwitchConfig;

  @property({ type: Object, attribute: true, reflect: true })
  itemRight: SwitchConfig;

  @property({ type: Boolean, attribute: true, reflect: true })
  disabled = false;

  render(): TemplateResult {
    const itemLeft = this.itemLeft;
    const itemRight = this.itemRight;

    return html`
      <div class="container" @change="${this.handleChange}">
        <input
          id="toggle-left"
          class="toggle toggle-left"
          name="toggle"
          value="${itemLeft.value}"
          type="radio"
          .checked="${itemLeft.checked}"
          ?disabled="${ifDefined(this.disabled || itemLeft.disabled)}"
        />
        <label for="toggle-left">
          <gz-tooltip tooltipText=${this.getTooltipTextForLabel(itemLeft)} ?isEllipsis=${!itemLeft.disabled}>
            <gz-text fontSize="11" fontWeight="500">${itemLeft.label}</gz-text>
          </gz-tooltip>
        </label>
        <input
          id="toggle-right"
          class="toggle toggle-right"
          name="toggle"
          value="${itemRight.value}"
          type="radio"
          .checked="${itemRight.checked}"
          ?disabled="${ifDefined(this.disabled || itemRight.disabled)}"
        />
        <label for="toggle-right">
          <gz-tooltip tooltipText=${this.getTooltipTextForLabel(itemRight)} ?isEllipsis=${!itemRight.disabled}>
            <gz-text fontSize="11" fontWeight="500">${itemRight.label}</gz-text>
          </gz-tooltip>
        </label>
      </div>
    `;
  }

  private getTooltipTextForLabel(item: SwitchConfig) {
    if (item.disabled) {
      return item.disabledTooltipText || item.label;
    }

    return item.label;
  }

  private handleChange(Event: Event): void {
    const value = Event.target?.['value'];

    if (isEmpty(value)) {
      return;
    }

    this.dispatchEvent(
      new CustomEvent(LabelSwitchEvents.CHANGE, {
        detail: {
          selectedValue: value,
        },
        bubbles: true,
        composed: true,
      })
    );
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'gz-label-switch': GzLabelSwitchWebComponent;
  }
}
